
export enum WatchlistType {
    SYSTEM = "SYSTEM",
    USER = "USER"
}
